// Süresiz paketler (Ücretsiz) backend'de 9999-12-31 bitiş tarihiyle gelir.
export const isUnlimitedDate = (d) => {
    if (!d) return false;
    const date = new Date(d);
    return !Number.isNaN(date.getTime()) && date.getFullYear() >= 9999;
};

export const formatLicenseDate = (d, empty = "-") => {
    if (!d) return empty;
    if (isUnlimitedDate(d)) return "Süresiz";
    return new Date(d).toLocaleDateString("tr-TR");
};

export const formatDaysLeft = (days, endDate, empty = "-") => {
    if (isUnlimitedDate(endDate)) return "Süresiz";
    return days != null ? `${days} gün` : empty;
};
